import ViewSection from "./ViewSection";

import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const LabourerProjectView = ({ project, onCloseClicked }) => {
  return (
    <div className="bg-white rounded-lg border border-ase-blue min-w-[900px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>{project.name}</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex flex-col gap-2 p-4">
        <p><b>Address:</b> {project.address}</p>
        <p><b>Status: </b> {project.status}</p>

        <div className="flex items-center gap-2">
          <p><b>Start date:</b> {formatDateToSydneyTimeZone(project.startDate)}</p>
          <p><b>End date:</b> {formatDateToSydneyTimeZone(project.endDate)}</p>
        </div>
      </div>

      <ViewSection
        expandable={true}
        title='Additional Information'
        content={(
          <div className="p-4 tiptap" dangerouslySetInnerHTML={{ __html: project?.additionalInformation }}></div>
        )}
      />
    </div>
  )
}

export default LabourerProjectView;
